import { lang } from '../../localization'
import { MappedChannelForAccommodation } from '../../types/reserveMonitoringList'
import MonitoringReserveTableSkeleton from './MonitoringReserveTable.skeleton'
import MonitoringReserveTableDynamicContent from './MonitoringReserveTableDynamicContent'
import MonitoringReserveTableFixedTitles from './MonitoringReserveTableFixedTitles'
import useStyles from './styles/MonitoringReserveTable.styles'

type MonitoringReserveTableProps = {
  uniqueChannelNames: string[]
  mappedChannelsForAccommodation: MappedChannelForAccommodation[]
  loadingForReserveMonitoringList: boolean
  AccommodationIds: string[]
}

export default function MonitoringReserveTable({
  uniqueChannelNames,
  mappedChannelsForAccommodation,
  loadingForReserveMonitoringList,
  AccommodationIds
}: MonitoringReserveTableProps) {
  const classes = useStyles()

  const accommodationsNames = mappedChannelsForAccommodation
    .filter((ele) => AccommodationIds.includes(ele.accommodationId))
    .map((ele) =>
      lang === 'en'
        ? ele.accommodationName
        : ele.accommodationNameTranslatedList[0].value
    )

  if (loadingForReserveMonitoringList) {
    return (
      <div className={classes.rootSkeleton}>
        {Array(30)
          .fill(' ')
          .map(() => (
            <MonitoringReserveTableSkeleton />
          ))}
      </div>
    )
  } else {
    return (
      <div className={classes.root}>
        <MonitoringReserveTableFixedTitles
          accommodationsNames={accommodationsNames}
        />
        <MonitoringReserveTableDynamicContent
          uniqueChannelNames={uniqueChannelNames}
          mappedChannelsForAccommodation={mappedChannelsForAccommodation}
          AccommodationIds={AccommodationIds}
        />
      </div>
    )
  }
}
